import styled from "styled-components"

export const TableHeadContainer = styled.thead`

`
export const TableBody = styled.tbody`

    & > tr:hover  {
        background-color: black
    }

    & > tr:hover > td > button {
        background-color: #40a9ff;
    }

`
export const TableHead = styled.th`
    display: flex;
    flex: 1;
    margin-left: 10px;
    color: #8c8c8c;
    width: inherit;
    height: 70px;
    font-weight:400 ;
    align-items:center;
    /* padding-top:10px ; */


    /* @media screen and (max-width: 950px){
        justify-content: center;
    } */

`
export const RankTableHead = styled.th`
    display: flex;
    flex: 1;
    margin-left: 10px;
    color: #8c8c8c;
    width: inherit;
    align-items:center;
    font-weight:400 ;
    
    /* padding-top:10px ; */
    



    /* @media screen and (max-width: 540px){
        font-size: 14px;
        display: none;
    } */


`

export const LastTableHead = styled.th`
    display: flex;
    /* flex: 1; */
    width:100px;
    font-weight:400 ;
    justify-content:flex-start;
    margin-left: 10px;
    color: #8c8c8c;
    align-items:center;
    /* width: inherit; */

    /* @media screen and (max-width: 500px){
        font-size: 14px;
        display: none;
    } */



`
export const TableRow = styled.tr`
    display: flex;
    flex-direction: row;
    height: 70px;
    border-bottom: 1px #595959 solid;
    cursor: pointer;


        /* @media screen and (max-width: 950px){
        justify-content: center;
    } */

`

export const TableData = styled.td`
    display: flex;
    flex: 1;
    margin-left: 10px;
    font-size: 16px;
    align-items: center;

    /* @media screen and (max-width: 950px){
        justify-content: center;
    }


    @media screen and (max-width: 540px){
        font-size: 14px;
    } */
`
export const RankTableData = styled.td`
    display: flex;
    flex: 1;
    margin-left: 10px;
    font-size: 16px;
    align-items: center;


    /* @media screen and (max-width: 950px){
        justify-content: center;
        text-align:center;
    } */

    /* @media screen and (max-width: 540px){
        font-size: 14px;
        display: none;
    } */
`

export const LastTableData = styled.td`
    display: flex;
    /* flex: 1; */
    width:100px;
    justify-content:flex-start;
    margin-left: 10px;
    font-size: 16px;
    align-items: center;

    /* @media screen and (max-width: 500px){
        font-size: 14px;
        display: none;
    } */
`

export const FirstTableData = styled.td`
    display: flex;
    flex: 1;
    margin-left: 10px;
    font-size: 16px;
    align-items: center;
    justify-content: flex-start;
`

export const RentMebutton = styled.button`
    display: flex;
    flex: 1;
    font-size: 16px;
    align-items: center;
    text-align: center;
    justify-content:center;
    max-width: 104px;
    border-radius: 10px;
    padding: 10px 7px;
    margin-right:5px;
    background-color:black;
    color:white;
    border: none;

    &:hover{
        background-color: #40a9ff;
    }


`

export const FirstDataField= styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`
export const FirstDataFieldCaption = styled.div`
    font-size: 13px;
`
export const SecondDataFieldCaption = styled.div`
    font-size: 9px;
`

export const FirstDataFieldImage = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 10px;

    @media screen and (max-width: 700px){
        display: none;
    }

`